var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_RosterForm_form_dialog_newShiftBtnTitle"),
      width: "600",
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            items: _vm.ShiftList,
                            "item-text": "shift_name",
                            "item-value": "uuid",
                            multiple: "",
                            label:
                              "label_essweb_RosterForm_form_dialog_shiftNameLabel",
                            "small-chips": "",
                            chips: "",
                            "single-line": "",
                            rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                          },
                          model: {
                            value: _vm.shift,
                            callback: function ($$v) {
                              _vm.shift = $$v
                            },
                            expression: "shift",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { okBtn: "" },
              on: { cancel: _vm.closeDialog, ok: _vm.toSave },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }